interface Props {
  message: string;
}

export default function EmptyState({
  message,
}: Props) {
  return (
    <div className="rounded-xl border border-dashed border-slate-300 p-8 text-center text-slate-500">
      {message}
    </div>
  );
}